import { Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";
import { BRAND } from "@/lib/data";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} · ${BRAND.name}`;
  }, [title]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-white/70 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-logo">
            <img src={BRAND.logo} alt={BRAND.name} className="h-10 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono-label text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors"
            data-testid="legal-back"
          >
            <ArrowLeft size={14} /> Back to Home
          </Link>
        </div>
      </header>

      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-4xl mx-auto px-6 py-16 lg:py-24"
      >
        <p className="overline text-accent mb-6">Legal</p>
        <h1 className="font-display text-5xl sm:text-6xl leading-none tracking-tight">{title}</h1>
        {updated && (
          <p className="mt-5 font-mono-label text-xs uppercase tracking-widest text-muted-foreground">
            Last updated · {updated}
          </p>
        )}
        <div className="legal-body mt-12 space-y-10">{children}</div>
      </motion.main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ n, title, children }) => (
  <section className="grid grid-cols-12 gap-4 border-t border-border pt-10">
    <div className="col-span-12 sm:col-span-2">
      <span className="font-mono-label text-sm text-accent">{n}</span>
    </div>
    <div className="col-span-12 sm:col-span-10">
      <h2 className="font-display text-2xl sm:text-3xl tracking-tight leading-tight mb-4">{title}</h2>
      <div className="space-y-4 text-muted-foreground text-base leading-relaxed">{children}</div>
    </div>
  </section>
);
